const CALCULATION_MILLISECONDS_TO_WAIT = 0;

export { CALCULATION_MILLISECONDS_TO_WAIT };
